import axios from 'axios';

async function ObtenerBanners(prmFiltro: string = '', prmCantidad: number = 0) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_banners"
    
    let datosEnvio;
    
    if (prmFiltro) {
        datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "filtro": prmFiltro, "cantidad": prmCantidad}
    } else {
        datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "cantidad": prmCantidad}
    }
    
    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerBanners;